import {
  LayoutDashboard,
  Boxes,
  ArrowLeftRight,
  AlertTriangle,
  BookOpen,
  ClipboardList,
  Send,
  Layers,
  FlaskConical,
  Trash2,
  ShoppingBag,
  UserRound,
  FileText,
  Percent,
  CreditCard,
  CalendarCheck,
  Wallet,
  Receipt,
  Store,
  Scale,
  HandCoins,
  KeyRound,
  GitBranch,
  LineChart,
  TrendingUp,
  BarChart,
  Gauge,
  ChevronLeft,
  Truck,
  GitBranchPlusIcon,
  UtensilsCrossed,
  PlusSquare,
  ReceiptText,
  TruckIcon,
  Table,
  KeyIcon,
} from "lucide-react";

import logo from "../../assets/images/logo.png";
import PortalNavigation from '../../components/ui/PortalNavigation';
import {canPage} from '../../components/ui/PermissionButton';

export const modules = [
  {
    title: "Core",
    items: [
      {
        label: "Dashboard",
        permission: "dashboard",
        icon: LayoutDashboard,
        path: "/admindashboard",
      },
      {label:'Notifications',icon:ClipboardList,path:'/admindashboard/notifications',permission:'notifications.view'},
      {label:'ERP Guide',icon:BookOpen,path:'/admindashboard/help',permission:'help.view'},
    ],
  },
  {
    title: "Vendors",
    items: [
      {
        label: "Vendors List",
        icon: Store,
        path: "/admindashboard/vendors",
        permission: "vendors.view",
      },
      {
        label: "Vendors Quotations",
        icon: Scale,
        path: "/admindashboard/vendors/quotationscompare",
        permission: "vendor_quotations.view",
      },
      {
        label: "Vendor Payments",
        icon: HandCoins,
        path: "/admindashboard/vendors/commissions",
        permission: "vendor_payments.manage",
      },
    ],
  },
  {
    title: "Purchase Orders",
    items: [
      {
        label: "Purchase Order",
        icon: ClipboardList,
        path: "/admindashboard/poc",
        permission: "purchase_orders.create",
      },
      {
        label: "PO Review & Sending",
        icon: Send,
        path: "/admindashboard/po/review",
        permission: "purchase_orders.approve",
      },
      {
        label: "PO Tracking",
        icon: TruckIcon,
        path: "/admindashboard/po/tracking",
        permission: "po.tracking",
      },
    ],
  },
  {
    title: "Inventory",
    items: [
      {label:"Material Handover",icon:Layers,path:"/admindashboard/inventory/material-issues",permission:"material_issues.view"},
      {label:"Department Materials",icon:Layers,path:"/admindashboard/inventory/material-issues/department-materials",permission:"material_issues.view"},
      {label:"Department Reconciliation",icon:Layers,path:"/admindashboard/inventory/material-issues/reconciliation",permission:"material_issues.view"},
      {
        label: "View Inventory",
        icon: Boxes,
        path: "/admindashboard/inventory",
        permission: "inventory.view",
      },
      {
        label: "Inward / Outward",
        icon: ArrowLeftRight,
        path: "/admindashboard/inventory/inward-history",
        permission: "inventory.movement",
      },
      {
        label: "Stock Alerts",
        icon: AlertTriangle,
        path: "/admindashboard/inventory/alerts",
        permission: "inventory.alerts",
      },
    ],
  },
  {
    title: "Production",
    items: [
      {
        label: "Recipes",
        icon: BookOpen,
        path: "/admindashboard/production/recipes",
        permission: "production.recipes",
      },
      {
        label: "Kitchen Orders", icon: Layers, path: "/admindashboard/production/kitchen", permission: "kitchen.view",
      },
      {
        label: "Batches",
        icon: Layers,
        path: "/admindashboard/production/batches",
        permission: "production.batches",
      },
      {
        label: "Raw Usage",
        icon: FlaskConical,
        path: "/admindashboard/production/materials",
        permission: "production.raw_usage",
      },
      {
        label: "Waste",
        icon: Trash2,
        path: "/admindashboard/production/waste",
        permission: "production.waste",
      },
    ],
  },
  {
    title: "Branches",
    items: [
      {
        label: "Branches",
        icon: GitBranch,
        path: "/admindashboard/branches",
        permission: "branches.view",
      },
      {
        label: "Counters",
        icon: Table,
        path: "/admindashboard/counters",
        permission: "counters.view",
      },
      {
        label: "Branch Demands",
        icon: GitBranchPlusIcon,
        path: "/admindashboard/branches/demands",
        permission: "branches.demands",
      },
      {
        label: "Stock Transfer",
        icon: Truck,
        path: "/admindashboard/branches/stocktransfer",
        permission: "branches.transfer",
      },
      {
        label: "Reports",
        icon: LineChart,
        path: "/admindashboard/branches/reports",
        permission: "branches.reports",
      },
    ],
  },
  {
    title: "Menu",
    items: [
      {
        label: "Menu Items",
        icon: UtensilsCrossed,
        path: "/admindashboard/menu-master",
        permission: "menu.view",
      },
      {
        label: "Add Menu Items",
        icon: PlusSquare,
        path: "/admindashboard/menu-master/add",
        permission: "menu.create",
      },
      {
        label: "All Bills",
        icon: ReceiptText,
        path: "/admindashboard/menu-master/bills",
        permission: "menu.bills",
      },
    ],
  },
  {
    title: "Sales & CRM",
    items: [
      {
        label: "Orders",
        icon: ShoppingBag,
        path: "/admindashboard/sales/orders",
        permission: "orders.view",
      },
      {
        label: "Customers",
        icon: UserRound,
        path: "/admindashboard/sales/customers",
        permission: "customers.view",
      },
    ],
  },
  {
    title: "Billing",
    items: [
      {
        label: "Invoices",
        icon: FileText,
        path: "/admindashboard/billing/invoices",
        permission: "invoices.view",
      },
      {
        label: "GST Reports",
        icon: Percent,
        path: "/admindashboard/billing/gst",
        permission: "gst.reports",
      },
      {
        label: "Payments",
        icon: CreditCard,
        path: "/admindashboard/billing/payments",
        permission: "payments.manage",
      },
    ],
  },
  {
    title: "Accounting",
    items: [
      {
        label: "Chart of Accounts",
        icon: BookOpen,
        path: "/admindashboard/accounting/chartofaccounts",
        permission: "accounting.coa",
      },
      {
        label: "Journal Entries",
        icon: FileText,
        path: "/admindashboard/accounting/journal-entries",
        permission: "accounting.journal",
      },
      {
        label: "General Ledger",
        icon: BookOpen,
        path: "/admindashboard/accounting/general-ledger",
        permission: "accounting.ledger",
      },
      {
        label: "Trial Balance",
        icon: Scale,
        path: "/admindashboard/accounting/trial-balance",
        permission: "accounting.trial_balance",
      },
      {
        label: "Profit & Loss",
        icon: TrendingUp,
        path: "/admindashboard/accounting/profit-loss",
        permission: "accounting.profit_loss",
      },
      {
        label: "Balance Sheet",
        icon: BarChart,
        path: "/admindashboard/accounting/balance-sheet",
        permission: "accounting.balance_sheet",
      },
      {
        label: "Cash Book",
        icon: Wallet,
        path: "/admindashboard/accounting/cash-book",
        permission: "accounting.cash_book",
      },
      {
        label: "Bank Book",
        icon: CreditCard,
        path: "/admindashboard/accounting/bank-book",
        permission: "accounting.bank_book",
      },
      {
        label: "Expenses",
        icon: Receipt,
        path: "/admindashboard/accounting/expenses",
        permission: "accounting.expenses",
      },
      {
        label: "Income",
        icon: HandCoins,
        path: "/admindashboard/accounting/income",
        permission: "accounting.income",
      },
    ],
  },
  {
    title: "HR & Payroll",
    items: [
      {
        label: "Attendance",
        icon: CalendarCheck,
        path: "/admindashboard/payroll/attendance",
        permission: "attendance.view",
      },
      {
        label: "Salary",
        icon: Wallet,
        path: "/admindashboard/payroll/salary",
        permission: "salary.manage",
      },
      {label:'Off-cycle Payroll',icon:Wallet,path:'/admindashboard/payroll/off-cycle',permission:'salary.manage'},
      {label:'Off-cycle Payslips',icon:Receipt,path:'/admindashboard/payroll/off-cycle-payslips',permission:'payslips.view'},
      {
        label: "Payslips",
        icon: Receipt,
        path: "/admindashboard/payroll/payslips",
        permission: "payslips.view",
      },
    ],
  },
  {
    title: "Access Control",
    items: [
      {
        label: "Staff Permissions",
        icon: KeyRound,
        path: "/admindashboard/access/permissions",
        permission: "staff.manage",
      },
      {
        label: 'Departments', icon: GitBranch, path: '/admindashboard/departments', permission: 'departments.manage', superAdminOnly: true,
      },
      {
        label: 'ERP Audit Logs', icon: ClipboardList, path: '/admindashboard/audit', permission: 'audit.view',
      },
      {
        label: "Roles",
        icon: KeyIcon,
        path: "/admindashboard/access/roles",
        permission: "staff.manage",
      },
      {label:'POS Controls & Receipts',icon:KeyRound,path:'/admindashboard/pos-settings',permission:'pos.settings.manage',superAdminOnly:true},
    ],
  },
  {
    title: "Reports",
    items: [
      {label:"Department Materials Report",icon:Layers,path:"/admindashboard/reports/department-materials",permission:"reports.department_materials"},
      {label:'Department Profitability',icon:BarChart,path:'/admindashboard/reports/department-profit',permission:'department_profit.view'},
      {label:'POS Operations',icon:ReceiptText,path:'/admindashboard/pos-operations',permission:'pos_operations.view'},
      {label:'Raw Material Report',icon:Boxes,path:'/admindashboard/reports/raw-materials',permission:'reports.raw_materials'},
      {label:'Department Material Transfers',icon:TruckIcon,path:'/admindashboard/reports/department-transfers',permission:'reports.department_transfers'},
      {label:'Department-wise Billing Sales',icon:BarChart,path:'/admindashboard/reports/department-sales',permission:'reports.department_sales'},
      {label:'Counter Daily Opening & Closing',icon:ReceiptText,path:'/admindashboard/reports/counter-daily',permission:'reports.counter_daily'},
      {
        label: "Sales Reports",
        icon: TrendingUp,
        path: "/admindashboard/reports/sales",
        permission: "reports.sales",
      },
      {
        label: "Finance Reports",
        icon: BarChart,
        path: "/admindashboard/reports/finance",
        permission: "reports.finance",
      },
      {
        label: "KPIs",
        icon: Gauge,
        path: "/admindashboard/reports/kpis",
        permission: "reports.kpi",
      },
    ],
  },
];

export default function Sidebar({
  permissions = [],
  role,
  collapsed,
  setCollapsed,
}) {
  const hasAccess = (perm,path='') => {
    if (role === "super_admin") return true;
    return canPage({user:{role},permissions},perm,path);
  };
  return (
    <aside
      className={`fixed left-0 top-0 z-40 h-screen
      ${collapsed ? "w-20" : "w-72"}
      bg-[#07070b] border-r border-white/10
      transition-all duration-300 flex flex-col`}
    >
      <div className="absolute top-0 left-0 h-full w-[2px] bg-gradient-to-b from-amber-400 via-yellow-500 to-amber-400" />

      <div className="flex items-center justify-between px-4 py-4">
        <div className="flex items-center gap-3 overflow-hidden">
          <img src={logo} alt="Jaggi Sweets" className="w-10 h-10 shrink-0" />
          {!collapsed && (
            <div>
              <h2 className="font-serif text-lg">Jaggi Sweets</h2>
              <p className="text-[10px] tracking-[0.3em] text-amber-400">
                EXECUTIVE ERP
              </p>
            </div>
          )}
        </div>

        <button
          type="button" aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 rounded-lg hover:bg-white/10 transition"
        >
          <ChevronLeft
            size={18}
            className={`transition-transform ${collapsed ? "rotate-180" : ""}`}
          />
        </button>
      </div>

      <PortalNavigation sections={modules.map(section => ({ ...section, items: section.items.filter(item => (!item.superAdminOnly || role === 'super_admin') && (!item.permission || hasAccess(item.permission, item.path)) && (!item.anyPermissions || item.anyPermissions.some(key => hasAccess(key, item.path)))) })).filter(section => section.items.length)} collapsed={collapsed} />

      {!collapsed && (
        <div className="px-6 py-4 border-t border-white/10 text-xs text-gray-400">
          © {new Date().getFullYear()} Jaggi Sweets
        </div>
      )}
    </aside>
  );
}
